export default __webpack_public_path__ + "d77371ddc9ddfe9a6333575f7d9f1529.webp";